import { useTheme, useMediaQuery } from "@mui/material"
import React, { ReactElement } from "react"
import CustomDrawer, { DrawerProps } from "./Drawer"
import Modal from "./Modal"

export default function DrawerModalWrapper({
  children,
  title,
  open,
  onClose,
}: DrawerProps): ReactElement {
  const theme = useTheme()
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"))

  return isMdDown ? (
    <CustomDrawer title={title} open={open} onClose={onClose}>
      {children}
    </CustomDrawer>
  ) : (
    <Modal title={title} open={open} onClose={onClose}>
      {children}
    </Modal>
  )
}
